'use client';

import { useState } from 'react';
import { ExpandMoreIcon } from '../icons';
import styles from './BrandDetail.module.css';

interface FAQItem {
  question: string;
  answer: string;
}

interface BrandDetailFAQProps {
  faq: FAQItem[];
  title: string;
}

export function BrandDetailFAQ({ faq, title }: BrandDetailFAQProps) {
  const [expanded, setExpanded] = useState<number | false>(false);

  return (
    <section className={styles.faqSection} itemScope itemType="https://schema.org/FAQPage">
      <h2 className={`${styles.sectionTitle} ${styles.sectionTitleLeft}`}>{title}</h2>
      {faq.map((item, i) => (
        <div
          key={i}
          className={styles.faqItem}
          itemScope
          itemProp="mainEntity"
          itemType="https://schema.org/Question"
        >
          <div
            className={styles.faqItemHeader}
            onClick={() => setExpanded(expanded === i ? false : i)}
          >
            <p className={styles.faqItemQuestion} itemProp="name">{item.question}</p>
            <span className={`${styles.faqItemIcon} ${expanded === i ? styles.faqItemIconExpanded : ''}`}>
              <ExpandMoreIcon />
            </span>
          </div>
          {expanded === i && (
            <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
              <p className={styles.faqItemAnswer} itemProp="text">{item.answer}</p>
            </div>
          )}
        </div>
      ))}
    </section>
  );
}
